import { Dispatch } from "redux";
import { WATERMARKING } from "constants/action-types";
import { IWatermarking } from "reducers/watermarking";
import { IStore } from "reducers";

export const updateWatermarkingSettings = (body: IWatermarking) => ({
    payload: body,
    type: WATERMARKING.UPDATE.START,
});

export const fetchWatermarkingDetails = () => (dispatch: Dispatch<{}>, getStore: () => IStore) => {
    if (getStore().scope.brand.hasPreference("add_watermarking")) {
        dispatch({ type: WATERMARKING.FETCH.START });
    }
};

export const fetchWatermarkingPreview = () => ({
    type: WATERMARKING.PREVIEW.START,
});
